import {
  Component,
  inject,
  OnInit,
  TemplateRef,
} from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BulkCreateRateModalComponent } from '../../components/bulk-create-rate-modal/bulk-create-rate-modal.component';
import { ZoneService } from 'src/app/services/modules/instant-rate-manager/zone.service';
import { RateManagerService } from 'src/app/services/modules/instant-rate-manager/rate-manager.service';
import { AlertUtil } from 'src/app/shared/utils/alert-dialog.util';

interface TermsCategoryOption {
  value: string;
  label: string;
  description: string;
}

@Component({
  selector: 'app-instant-rates-manager',
  templateUrl: './instant-rates-manager.component.html',
  styleUrl: './instant-rates-manager.component.scss',
})
export class InstantRatesManagerComponent implements OnInit {
  router = inject(Router);
  modalService = inject(NgbModal);
  private zoneService = inject(ZoneService);
  private rateManagerService = inject(RateManagerService);

  hasNoZones = false;
  termsCategories: TermsCategoryOption[] = [];
  isLoadingTermsCategories = false;

  ngOnInit() {
    this.checkZones();
  }

  async checkZones() {
    try {
      const response = await this.zoneService.getProviderZones({
        page_size: 1,
        is_active: true,
      });
      this.hasNoZones = response.count === 0;
    } catch (error) {
      console.error('Error checking zones:', error);
    }
  }

  goTo = (url: string) => {
    this.router.navigate([url]);
  };

  openBulkUploadRateModal = async () => {
    if (this.hasNoZones) {
      await AlertUtil.info(
        'You must have at least one zone set up before you can import rates.'
      );
      this.goTo('/instant-rate-manager/provider-locations');
      return;
    }

    this.modalService.open(BulkCreateRateModalComponent, {
      size: 'lg',
      centered: true,
    });
  };

  openTermsSelectionModal = async (template: TemplateRef<any>) => {
    this.isLoadingTermsCategories = true;
    this.termsCategories = [];

    try {
      const response = await this.rateManagerService.getProviderRatesCategories({}, true);
      this.termsCategories = (response?.data ?? []).map((item: any) => ({
        value: String(item.id),
        label: item.name ? item.name.charAt(0).toUpperCase() + item.name.slice(1) : item.name,
        description: item.description || `Manage terms for ${item.name} freight.`,
      }));
    } catch {
      AlertUtil.error('Failed to load categories.');
      return;
    } finally {
      this.isLoadingTermsCategories = false;
    }

    this.modalService.open(template, { centered: true, size: 'lg' });
  };

  goToGeneralTerms = () => {
    this.modalService.dismissAll();
    this.goTo('/instant-rate-manager/applied-terms');
  };

  goToCategoryTerms = (categoryId: string) => {
    this.modalService.dismissAll();
    this.goTo(`/instant-rate-manager/applied-terms/category/${categoryId}`);
  };
}
